// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CEgYx","content":"styles_content__1XB9y","row":"styles_row__b5IKo","footer":"styles_footer__d1s1Y","phraseLength":"styles_phraseLength__3s-2B"};